import { CheckoutProbabilityPredictionRange } from "@redotech/redo-conversion-core-common/conversion/checkout-probability";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getCheckoutProbabilityMeasurementMetrics = {
  name: "getCheckoutProbabilityMeasurementMetrics" as const,
  input: z.object({
    /**
     * Optional window. Both bounds are required when present so a half-open
     * range can't be expressed.
     */
    dateRange: z
      .object({ start: zExt.instant(), end: zExt.instant() })
      .optional(),
  }),
  output: z.object({
    checkoutProbabilityMeasurementMetrics: z.record(
      createEnum(CheckoutProbabilityPredictionRange),
      z.object({
        checkoutCompletionsRate: z.number(),
        totalCompletedCheckouts: z.number(),
        totalSessions: z.number(),
      }),
    ),
  }),
};
